<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">phone</v-icon>
			<v-toolbar-title>Dane teleadresowe</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4" v-if="dataFetched">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>E-mail organizacji</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="organizationMail"
						data-vv-as="E-mail organizacji"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.organizationMail')"
						v-model="data.organizationMail"
						v-validate="'required|email'"
						data-vv-validate-on="none"
						data-vv-scope="addressDataScope"
						aria-label="label for email">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Strona internetowa</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="websiteAddress"
						data-vv-as="Strona internetowa"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.websiteAddress')"
						v-model="data.websiteAddress"
						data-vv-validate-on="none"
						v-validate="{url: {require_protocol: false }}"
						data-vv-scope="addressDataScope"
						aria-label="label for website"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Telefon</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="organizationPhoneNumber"
						data-vv-as="Telefon"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.organizationPhoneNumber')"
						v-model="data.organizationPhoneNumber"
						v-validate="{required: true, regex: /^([(][0-9 +-]*[)])?[0-9 +-]*$/}"
						data-vv-validate-on="none"
						data-vv-scope="addressDataScope"
						aria-label="label for phone"
					></v-text-field>
				</v-flex>
			</v-layout>

			<div class="ma-4">
				<v-layout row>
					<v-flex xs4/>
					<v-flex xs3>
						<div class="text-xs-center"><h3>Adres siedziby</h3></div>
					</v-flex>
				</v-layout>
			</div>

			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Ulica</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="street"
						data-vv-as="Ulica"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.street')"
						v-model="data.address.street"
						v-validate="'required'"
						data-vv-scope="addressDataScope"
						aria-label="label for street"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Numer domu</v-subheader>
				</v-flex>
				<v-flex xs2>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="building"
						data-vv-as="Numer domu"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.building')"
						v-model="data.address.building"
						v-validate="'required'"
						data-vv-scope="addressDataScope"
						aria-label="label for address"
					></v-text-field>
				</v-flex>
				<v-flex xs1>
					<v-subheader>Numer lokalu</v-subheader>
				</v-flex>
				<v-flex xs3>
					<v-text-field
						browser-autocomplete="off"
						:readonly="readOnlyMode"
						v-model="data.address.apartment"
						aria-label="label for apartment"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<div class="text-xs-center">
						<v-subheader class="text-xs-center">Kod pocztowy</v-subheader>
					</div>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="postalCode"
						data-vv-as="Kod pocztowy"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.postalCode')"
						v-model="data.address.postalCode"
						data-vv-validate-on="none"
						v-validate="{ required: true, regex: /^([0-9]{2}-[0-9]{3})$/}"
						return-masked-value
						:mask="'##-###'"
						data-vv-scope="addressDataScope"
						aria-label="label for postal code"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Miejscowość</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="city"
						data-vv-as="Miejscowość"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.city')"
						v-model="data.address.city"
						v-validate="'required'"
						data-vv-scope="addressDataScope"
						aria-label="label for city"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Województwo</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-select
						data-vv-name="province"
						data-vv-as="Województwo"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.province')"
						v-model="data.province"
						:items="provinceItems"
						v-validate="'required'"
						data-vv-scope="addressDataScope"
						aria-label="label for province"
					></v-select>
				</v-flex>
			</v-layout>

			<div v-if="!readOnlyMode" class="mt-4">
				<v-layout row>
					<v-flex xs1/>
					<v-flex xs2>
						<v-btn
							@click="handleCorrespondenceChosen"
							dark
							color="primary" class="white--text mb-5"
							:disabled="readOnlyMode">
							Adres korespondencyjny
							<v-icon class="ml-2" v-if="!correspondenceAddress">add_circle</v-icon>
							<v-icon class="ml-2" v-else>remove_circle</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</div>
			<div v-else>
				<v-layout row>
					<v-flex xs4/>
					<v-flex xs3>
						<div class="text-xs-center ma-4"><h3>Adres korespondencyjny</h3></div>
					</v-flex>
				</v-layout>
				<div v-if="!correspondenceAddress">
					<v-layout row>
						<v-flex xs4/>
						<v-flex xs3>
							<div class="text-xs-center"><h3>(Brak)</h3></div>
						</v-flex>
					</v-layout>
				</div>
			</div>

			<v-expand-transition>
				<div v-if="correspondenceAddress">
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<v-subheader>Ulica</v-subheader>
						</v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="correspondenceStreet"
								data-vv-as="Ulica"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('addressDataScope.correspondenceStreet')"
								v-model="data.correspondenceAddress.street"
								v-validate="'required'"
								data-vv-scope="addressDataScope"
								aria-label="label for street"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<v-subheader>Numer domu</v-subheader>
						</v-flex>
						<v-flex xs2>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="correspondenceBuilding"
								data-vv-as="Numer domu"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('addressDataScope.correspondenceBuilding')"
								v-model="data.correspondenceAddress.building"
								v-validate="'required'"
								data-vv-scope="addressDataScope"
								aria-label="label for building"
							></v-text-field>
						</v-flex>
						<v-flex xs1>
							<v-subheader>Numer lokalu</v-subheader>
						</v-flex>
						<v-flex xs3>
							<v-text-field
								browser-autocomplete="off"
								:readonly="readOnlyMode"
								v-model="data.correspondenceAddress.apartment"
								aria-label="label for apartment"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<div class="text-xs-center">
								<v-subheader class="text-xs-center">Kod pocztowy</v-subheader>
							</div>
						</v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="correspondencePostalCode"
								data-vv-as="Kod pocztowy"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('addressDataScope.correspondencePostalCode')"
								v-model="data.correspondenceAddress.postalCode"
								data-vv-validate-on="none"
								v-validate="{ required: true, regex: /^([0-9]{2}-[0-9]{3})$/}"
								return-masked-value
								:mask="'##-###'"
								data-vv-scope="addressDataScope"
								aria-label="label for postal code"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<v-subheader>Miejscowość</v-subheader>
						</v-flex>
						<v-flex xs6>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="correspondenceCity"
								data-vv-as="Miejscowość"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('addressDataScope.correspondenceCity')"
								v-model="data.correspondenceAddress.city"
								v-validate="'required'"
								data-vv-scope="addressDataScope"
								aria-label="city"
							></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs2>
							<v-subheader>Województwo</v-subheader>
						</v-flex>
						<v-flex xs6>
							<v-select
								data-vv-name="correspondenceProvince"
								data-vv-as="Województwo"
								:readonly="readOnlyMode"
								:error-messages="vErrors.collect('addressDataScope.correspondenceProvince')"
								v-model="data.correspondenceProvince"
								:items="provinceItems"
								v-validate="'required'"
								aria-label="correspondence province"
								data-vv-scope="addressDataScope"
							></v-select>
						</v-flex>
					</v-layout>
				</div>
			</v-expand-transition>

		</div>
	</v-card-text>
</template>

<script>
	export default {
		name: "AddressProfileDataView",

		data() {
			return {
				readOnlyMode: true,

				data: {},

				dataFetched: false,

				correspondenceAddress: false,

				provinceItems: [
					"dolnośląskie",
					"kujawsko-pomorskie",
					"lubelskie",
					"lubuskie",
					"łódzkie",
					"małopolskie",
					"mazowieckie",
					"opolskie",
					"podkarpackie",
					"podlaskie",
					"pomorskie",
					"śląskie",
					"świętokrzyskie",
					"wamińsko-mazurskie",
					"wielkopolskie",
					"zachodniopomorskie",
				],
			};
		},

		methods: {
			handleCorrespondenceChosen() {
				this.correspondenceAddress = !this.correspondenceAddress;

				if (this.correspondenceAddress === false) {
					this.data.correspondenceAddress.city = "";
					this.data.correspondenceAddress.apartment = "";
					this.data.correspondenceAddress.building = "";
					this.data.correspondenceAddress.street = "";
					this.data.correspondenceAddress.postalCode = "";
					this.data.correspondenceProvince = undefined;
				}
			},
		},

		watch: {
			addressData: function () {
				this.data = this.addressData;
				this.correspondenceAddress = this.data.correspondenceAddress.street !== "";
				this.dataFetched = true;
			},

			readOnlyMode: function (value) {
				if (value) {
					this.$validator.validateAll("addressDataScope").then(result => {
						if (result) {
							this.$emit("edition-status", !value);
						} else {
							this.readOnlyMode = !this.readOnlyMode;
						}
					});
				} else {
					this.$emit("edition-status", !value);
				}
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		props: {
			addressData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>
	.v-icon {
		color: #fff !important;
	}
</style>
